module.exports = __webpack_public_path__ + "img/38058ae4dd735bb65f37d82a731a08c9.png";